export enum Status {
  All = 'all',
  Active = 'active',
  Completed = 'completed',
}
